"use client";

import React, { useState } from "react";
import axios from "axios";
import { NODE_HOST_URL_v3 } from "./api/Api";
import styles from "./Onboarding.module.css";

import StepWelcome from "./StepWelcome";
import StepServices from "./StepServices";
import StepComplete from "./StepComplete";

const OnboardingStepper = ({ onFinish, onClose }) => {
  const [step, setStep] = useState(1);
  const [intent, setIntent] = useState("");
  const [services, setServices] = useState([]);

  const progress = step === 1 ? 32 : step === 2 ? 68 : 100;

  const handleDashboard = async () => {
    try {
      const lStorage = JSON.parse(localStorage.getItem("login"));
      const userId = lStorage?.user?.userId;
      const userToken = lStorage?.token;
      const userName = lStorage?.user?.username;

      await axios.post(`${NODE_HOST_URL_v3}/user/questioner`, {
        user_id: userId,
        token: userToken,
        method: "insert_questioner",
        description: intent,
        product: services.join(","),
        user_name: userName,
      });
    } catch (_) {
      // non-blocking — proceed even if API fails
    }
    onFinish();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close onboarding"
        >
          ×
        </button>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${progress}%` }}
          />
        </div>

        {step === 1 && (
          <StepWelcome
            intent={intent}
            setIntent={setIntent}
            onNext={() => setStep(2)}
          />
        )}

        {step === 2 && (
          <StepServices
            services={services}
            setServices={setServices}
            onBack={() => setStep(1)}
            onFinish={() => setStep(3)}
          />
        )}

        {step === 3 && (
          <StepComplete
            services={services}
            onDashboard={handleDashboard}
          />
        )}
      </div>
    </div>
  );
};

export default OnboardingStepper;
